import React, { useState, useEffect } from 'react';
import { VERSION } from '../version';

const VersionDisplay = () => {
  const [displayVersion, setDisplayVersion] = useState(VERSION || '0.9.103');

  useEffect(() => {
    // Force refresh version from server periodically to bypass cache
    const refreshVersion = async () => {
      try {
        // Try to get fresh version from server
        const response = await fetch('/version.js?' + Date.now(), { 
          cache: 'no-cache',
          headers: { 'Cache-Control': 'no-cache' }
        });
        
        if (response.ok) {
          const text = await response.text();
          const match = text.match(/export const VERSION = ['"]([^'"]+)['"]/);
          if (match) {
            setDisplayVersion(match[1]);
          }
        }
      } catch (error) {
        console.log('Version refresh failed, using static version:', VERSION);
        // Fallback to imported version with timestamp suffix
        setDisplayVersion(`${VERSION}-${Date.now().toString().slice(-4)}`);
      }
    };

    // Refresh version on mount and every 30 seconds
    refreshVersion();
    const interval = setInterval(refreshVersion, 30000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-secondary-100 text-secondary-600 px-2 py-1 rounded text-xs font-mono shadow-sm">
        v{displayVersion}
      </div>
    </div>
  );
};

export default VersionDisplay; 